import { useState } from "react";
import { useDebounce } from "@/shared/hooks";

/** Поиск в пикере уходит на сервер через 300 мс после последнего ввода. */
export const PICKER_SEARCH_DEBOUNCE_MS = 300;

/** Строка поиска пикера карточки и её отложенное значение для запроса. */
export const usePickerSearch = () => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, PICKER_SEARCH_DEBOUNCE_MS);
  return { search, setSearch, debouncedSearch };
};
